export const LOADER_DESC_COMPETENCIES          =     "LOADER_DESC_COMPETENCIES";
export const LOADER_DESC_COMPETENCIE           =     "LOADER_DESC_COMPETENCIE";
export const SAVE_LOADER_COMPETENCIES          =     "SAVE_LOADER_COMPETENCIES";
export const GET_DESC_COMPETENCIES             =     "GET_DESC_COMPETENCIES";
export const GET_DESC_COMPETENCIE              =     "GET_DESC_COMPETENCIE";
export const FORM_DESC_COMPETENCIEFAIL         =     "FORM_DESC_COMPETENCIEFAIL";
export const DESC_COMPETENCIES_FAIL            =     "DESC_COMPETENCIES_FAIL";
export const DESC_COMPETENCIE_FAIL             =     "DESC_COMPETENCIE_FAIL";